export default __webpack_public_path__ + "/dist/images/about-img1.png";